import { AUTH_AZURE_ERROR_CODE } from '../../constants';

const { NOT_CONFIRMED, NOT_FOUND, USER_DISABLED } = AUTH_AZURE_ERROR_CODE;

export function getAuthAzureErrorMessage(errorCode, formatMessage) {
  switch (errorCode) {
    case NOT_CONFIRMED:
      return formatMessage({ id: 'auth.errors.notConfirmed' });
    case NOT_FOUND:
      return formatMessage({ id: 'auth.errors.notFound' });
    case USER_DISABLED:
      return formatMessage({ id: 'auth.errors.userDisabled' });
    default:
      return formatMessage({ id: 'errors.common' });
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth/getAuthAzureErrorMessage.js